import React from 'react';
import cx from 'classnames';

import { Button } from '@motorway/mw-highway-code';
import { BUTTON_AS_TYPE, BUTTON_TYPE } from '@motorway/mw-highway-code/enums';

import { bereavementAboutParams, getBereavementPathWithParams } from 'Utilities/helpers';
import T from 'Utilities/texts';

import imageThreeAvif from '../../../../../../client/assets_seller/about_us/empathyv2.avif';
import imageThreeJpg from '../../../../../../client/assets_seller/about_us/empathyv2.jpg';
import imageThreeWebp from '../../../../../../client/assets_seller/about_us/empathyv2.webp';
import imageOneJpg from '../../../../../../client/assets_seller/about_us/iosApp.jpg';
import imageOneWebp from '../../../../../../client/assets_seller/about_us/iosApp.webp';
import imageTwoJpg from '../../../../../../client/assets_seller/about_us/vehicle-collection.jpg';
import imageTwoWebp from '../../../../../../client/assets_seller/about_us/vehicle-collection.webp';

import ImgBox from './imgBox';

import styles from './Info.scss';

const Info = () => (
  <section className={styles.outer}>
    <div className={cx(styles.infoBox, styles.reverse)}>
      <div className={styles.textBox}>
        <h3>
          {T.translate('aboutPage.info.photoApp.title')}
        </h3>
        <p className="mw-i">
          {T.translate('aboutPage.info.photoApp.description')}
        </p>
        <div className={styles.link}>
          <a className="mw-link mw-link-blue" href="/how-it-works">
            {T.translate('aboutPage.info.photoApp.link')}
          </a>
        </div>
      </div>
      <ImgBox
        imgHeight={1248}
        imgPng={imageOneJpg}
        imgWebp={imageOneWebp}
        imgWidth={2040}
        name="Photographing a car for sale using native application"
      />
    </div>
    <div className={styles.infoBox}>
      <div className={styles.textBox}>
        <h3>
          {T.translate('aboutPage.info.collection.title')}
        </h3>
        <p className="mw-i">{T.translate('aboutPage.info.collection.description')}</p>
        <div className={styles.link}>
          <Button
            data-thc-button
            as={BUTTON_AS_TYPE.ANCHOR}
            href="/"
            icon="arrow"
            label={T.translate('aboutPage.info.collection.button')}
            type={BUTTON_TYPE.BUTTON}
          />
        </div>
      </div>
      <ImgBox
        reverse
        imgHeight={898}
        imgPng={imageTwoJpg}
        imgWebp={imageTwoWebp}
        imgWidth={1371}
        name="Customer and dealer finalizing a car deal"
      />
    </div>
    <div className={cx(styles.infoBox, styles.reverse)}>
      <div className={styles.textBox}>
        <h3>
          {T.translate('aboutPage.info.empathy.title')}
        </h3>
        <p className="mw-i">{T.translate('aboutPage.info.empathy.description')}</p>
        <div className={styles.link}>
          <a
            className="mw-link mw-link-blue"
            href={getBereavementPathWithParams('/sell-my-car/bereavement', bereavementAboutParams)}
          >
            {T.translate('aboutPage.info.empathy.link')}
          </a>
        </div>
      </div>
      <ImgBox
        imgAvif={imageThreeAvif}
        imgHeight={783}
        imgPng={imageThreeJpg}
        imgWebp={imageThreeWebp}
        imgWidth={849}
        name="Motorway specialist offering support to a customer"
      />
    </div>
  </section>
);

export default Info;
